import { AfterViewInit, Component, ElementRef, Inject, OnInit, PLATFORM_ID, ViewChild } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { AuthService } from 'src/app/services/api/auth/auth.service';
import { Benefit, BenefitsService } from 'src/app/services/api/benefits/benefits.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { assetUrl } from 'src/app/globals/globals';
import { LocationService } from 'src/app/services/api/location/location.service';
import { SliderService } from 'src/app/services/api/sliders/slider.service';
import { Slider } from 'src/app/interfaces/sliders/sliders.interface';
import { isPlatformBrowser } from '@angular/common';



declare var google: any ;

declare global {
  interface Window { dataLayer: any[]; }
}


@Component({
  selector: 'app-benefit-details',
  templateUrl: './benefit-details.component.html',
  styleUrls: ['./benefit-details.component.scss']
})
export class BenefitDetailsComponent implements OnInit, AfterViewInit {
  assetUrl = assetUrl;

  @ViewChild('mapContainer', { static: false }) gmap: ElementRef;

  currentUser: any;
  guestUser: boolean = true;
  locations: any = [];
  daysAvailable           = '';
  markers                 = <any>[];
  showModal               = false;
  benefit: Benefit;
  benefits                = <any>null;
  filteredBenefits        = <any>[];
  loggedIn                = false;
  id                      = 0;
  name                    = '';
  benefitsSliderOptions   = <any>{}
  benefitCode:string | null             = '';
  codeCopied              = false;
  esCencosud              = false;
  esEasy                  = false;
    weekDays = [
    { label: 'D', value: 7 },
    { label: 'L', value: 1 },
    { label: 'M', value: 2 },
    { label: 'M', value: 3 },
    { label: 'J', value: 4 },
    { label: 'V', value: 5 },
    { label: 'S', value: 6 },
  ];
  activeDays: number[] = [];
  showBranches: boolean = false;
  showModalBranches: boolean = false;
  slidersBenefit?: any = [];

  constructor(  private benSer:         BenefitsService,
                private route:          ActivatedRoute,
    private spinnerService: NgxSpinnerService,
    private userService: AuthService,
    private router: Router,
    private sliderService: SliderService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.setMap();
    }
}

  ngOnInit()
  {
    if (isPlatformBrowser(this.platformId)) {
      document.addEventListener('UserSessionRefreshed', (e: Event) => {
        this.handleUser();
      }, false);
    }
    this.handleUser();

    // this.loadScript();
    this.route.params.subscribe(( params: Params ) =>
    {
      if(params['id']) {
        this.getBenefit( params['id'] )
        .then( () =>
        {

        });
      }else
      {

        this.esCencosud = params['name'].indexOf('-cencosud') != -1;

        this.esEasy = params['name'].indexOf('easy-') != -1;

        this.getBenefitByName( params['name'] )
        .then( () =>
        {

        });
      }
    });
    this.getSliderBenefits();
    setTimeout(() => {
      this.setMap();
    }, 1000);
  }
  async getSliderBenefits(): Promise<void> {
    try {
      const sliders = await this.sliderService.getSliderBenefits().toPromise();
      this.slidersBenefit = sliders?.[1] ? [sliders[1]] : [];
    } catch (error) {
      console.error('Error fetching slider benefits:', error);
    }
  }
  toggleBranches() {
    this.showBranches = !this.showBranches;
  }

  getBenefitTypeImage(type: string): string {
    return type === 'PRESENCIAL' ? 'assets/icon/icon-in-person.svg' : 'assets/icon/icon-online.svg';
  }
  isActiveDay(day: number): boolean {
    return this.activeDays.includes(day);
  }
  public loadScript(): void
  {
    if (isPlatformBrowser(this.platformId)) {
      const body        = document.body as HTMLDivElement;
      const script      = document.createElement('script');

      script.innerHTML  = '';
      script.src        = 'assets/js/init.js';
      script.async      = true;
      script.defer      = true;
      body.appendChild(script);
    }
  }

  openBranchesModal() {
    this.showModalBranches = true;
  }

  closeModal()
  {
    this.showModal = false;
  }
  async openModal()
  {
    this.showModal = true;
    const currentUser = await this.userService.getCurrentUser();
        if(currentUser) {
          if (isPlatformBrowser(this.platformId)) {
            window.dataLayer = window.dataLayer ||
            [];
            window.dataLayer.push({
            'event' : 'codigo-beneficio',
            'name': this.benefit.partner.name,
            'userId' : currentUser?.PersonID
            });
          }
        }
  }
  open(url:any)
  {
    if (isPlatformBrowser(this.platformId)) {
      window.open(url, '_blank')
    }
  }
  parseDays(days: string): number[] {
    return Array.from(new Set(days.split('').map(Number)));
  }

async getBenefit(id: number) {
  this.showSpinner();

  return this.benSer.getById(id).toPromise()
    .then(async (benefit: any) => {
      this.benefit = benefit;
      if (!this.benefit) {
        this.router.navigateByUrl('/');
      }

      this.benSer.selectBenefit(this.benefit);
      this.promoDaysMessage(this.benefit);

      if (this.benefit.days) {
        this.activeDays = this.parseDays(this.benefit.days);
      }

      if (this.benefit.branch) {
        this.locations = this.benefit.branch.map((b: any) => ({
          ...b.branch,
          city: '',
          province: '',
        }));
      }

      this.hideSpinner();

      setTimeout(() => { this.setMap() }, 1000);

      if(isPlatformBrowser(this.platformId)) {
        this.getBenefits();
      }

      const currentUser = await this.userService.getCurrentUser();
      if (currentUser) {
        if (isPlatformBrowser(this.platformId)) {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'detalle-beneficio',
            name: this.benefit.partner.name,
            userId: currentUser?.PersonID
          });
        }
      }
    })
    .catch(error => {
      console.log(error);
      this.router.navigateByUrl('/');
    });
}

  async getBenefitByName( name: string )
  {
    this.showSpinner();

    return this.benSer.getByName( name ).toPromise()
    .then(async (benefit: any) =>
    {
      this.benefit = benefit;

      if( !this.benefit ){
        this.router.navigateByUrl('/');
      }

      this.benefit = benefit;
      this.benSer.selectBenefit(this.benefit);
      this.promoDaysMessage(this.benefit);
      if (this.benefit.days) {
        this.activeDays = this.parseDays(this.benefit.days);
      }

      if (this.benefit.branch) {
        this.locations = this.benefit.branch.map((b: any) => ({
          ...b.branch,
          city: '',
          province: '',
        }));
      }

      this.hideSpinner();

      setTimeout(() => { this.setMap() }, 1000);

      if(isPlatformBrowser(this.platformId)) {
        this.getBenefits();
      }

      const currentUser = await this.userService.getCurrentUser();

        if(currentUser) {
          if (isPlatformBrowser(this.platformId)) {
            window.dataLayer = window.dataLayer ||
            [];
            window.dataLayer.push({
            'event' : 'detalle-beneficio',
            'name': this.benefit.partner.name,
            'userId' : currentUser?.PersonID
            });
          }
        }
    })
    .catch( error =>
    {
      console.log( error );
      this.router.navigateByUrl('/');
    });
  }
  showPlaceHolder()
  {
    return this.benefit.benefit_type === 'ONLINE' || this.benefit.branch.length === 0;
  }
  showBranchesMap()
  {
    return this.benefit.benefit_type !== 'ONLINE' && this.benefit.branch.length > 0;
  }
  setMap(): void {
    if (this.gmap && isPlatformBrowser(this.platformId)) {

      const map = new google.maps.Map(this.gmap.nativeElement, {
        disableDefaultUI: false,
        scrollwheel: false,
        gestureHandling: 'greedy',
        draggable: isPlatformBrowser(this.platformId) ? !('ontouchend' in document) : false,
      });
      this.setMapBranches(map);
    }
  }
  async handleModal(){
    if(!this.guestUser)
    {
      // if(!this.esCencosud) {
          this.benSer.benefitCodes(this.benefit)
          .then((code) => {

              this.benefitCode = code;
              this.showModal = true;
            })
            .catch((err) => {
              console.log(err)
            })
      // } else {
      //   this.showModal = true;
      // }

    }else
    {
      if (isPlatformBrowser(this.platformId)) {
        document.getElementsByClassName('modal-login')[0].classList.add('visible');
        document.getElementsByTagName('body')[0].classList.add('noScroll');
      }
    }
  }
  capitalizeEachWord(text: string): string {
    return text
      .toLowerCase()
      .replace(/\b\w/g, char => char.toUpperCase());
  }
  setMapBranches(map: any) {
    if (isPlatformBrowser(this.platformId)) {
      const bounds = new google.maps.LatLngBounds();

      let infoWindow = new google.maps.InfoWindow();

      this.locations.forEach((item: any) => {
        const icon = '/assets/icon/icon-maps.svg';
        const position = new google.maps.LatLng(item.latitude, item.longitude);
        const pixelOffset = new google.maps.Size(0, 0);
        const formattedAddress = this.capitalizeEachWord(item.address);
        const formattedCity = this.capitalizeEachWord(item.city);
        const formattedProvince = this.capitalizeEachWord(item.province);

        const parts = [];

        if (item.name) {
          parts.push(
            `<p class="branch-name" style="text-align:start;font-size: 14px; margin: 0;color: #404040;font-style: normal;font-weight: 700;line-height: 120%;">${item.name}</p>`
          );
        }

        const addressParts = [];
        if (formattedAddress) addressParts.push(formattedAddress);
        if (formattedCity) addressParts.push(formattedCity);
        if (formattedProvince) addressParts.push(formattedProvince);

        const addressString = addressParts.join(', ');

        if (addressString) {
          parts.push(
            `<p class="marker-name" style="text-align:start;font-size: 14px; margin: 0;font-weight: 400;line-height: 16.8px;letter-spacing: 0%;color: #595959;">${addressString}</p>`
          );
        }

        const content =
          `<div class="marker-content" style="max-width: 300px; display: flex; flex-direction: column; align-items: center; text-align: center;">` +
          `<div style="display: flex; align-items: center; gap: 10px;">` +
          `<img src="../../../assets/icon/icon-local.svg" style="width: 45px;"/>` +
          `<div style="display: flex; align-items: flex-start; gap: 10px; flex-direction: column;">` +
          parts.join('') +
          `</div>` +
          `</div>` +
          `</div>`;

        const marker = new google.maps.Marker({ position, map, icon });

        google.maps.event.addListener(marker, 'click', function () {
          infoWindow.setContent(content);
          infoWindow.open(map, marker);
        });

        marker.setMap(map);
        this.markers.push(position);
      });

      this.markers.forEach((mark: any) => bounds.extend(mark));
      this.centerMap(map, bounds);
    }
  }
  centerMapDiscount(map: any, bounds: any) {
    if (this.markers.length > 1) map.fitBounds(bounds);
    if (navigator.geolocation) {
      let markers = this.markers;

      navigator.geolocation.getCurrentPosition(function (position) {
        var initialLocation = new google.maps.LatLng(
          position.coords.latitude,
          position.coords.longitude
        );
        map.setCenter(initialLocation);

        var currentLocation = new google.maps.Marker({
          position: initialLocation,
          map,
        });
        currentLocation.setMap(map);

        setBounds();

        function rad(x: any) {
          return (x * Math.PI) / 180;
        }

        var lat = initialLocation.lat();
        var lng = initialLocation.lng();

        function nearestMarker() {
          var R = 6371; // radius of earth in km
          var distances = [];
          var closest = -1;

          for (let i = 0; i < markers.length; i++) {
            var mlat = markers[i].lat();
            var mlng = markers[i].lng();
            var dLat = rad(mlat - lat);
            var dLong = rad(mlng - lng);

            var a =
              Math.sin(dLat / 2) * Math.sin(dLat / 2) +
              Math.cos(rad(lat)) *
                Math.cos(rad(lat)) *
                Math.sin(dLong / 2) *
                Math.sin(dLong / 2);
            var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
            var d = R * c;

            distances[i] = d;

            if (closest == -1 || d < distances[closest]) {
              closest = i;
            }
          }

          return markers[closest];
        }

        function setBounds() {
          var closestMarker = nearestMarker();

          var bounds = new google.maps.LatLngBounds();
          bounds.extend(closestMarker);
          bounds.extend(initialLocation);
          map.fitBounds(bounds);
        }
      });
    } else if (this.markers.length > 1) map.fitBounds(bounds);
    else {
      const position = this.markers[0];
      map.setCenter(position);
      map.setZoom(15);
    }
  }
  centerMap( map: any, bounds: any )
  {
    if( this.markers.length > 1 )
      map.fitBounds( bounds );
    else
    {
      const position = this.markers[0];

      map.setCenter( position );
      map.setZoom( 15 );
    }
  }
  promoDaysMessage(ben: any)
  {
    const days: any = ben.days.split('').sort();
    const dayNames = [ 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábados', 'Domingo' ];

    if( days.length === 7 )
      this.daysAvailable = 'todos los días';
    else
    {
      if( days.includes( [1, 2, 3, 4, 5] ) )
        this.daysAvailable = 'de Lunes a Viernes';
      else
      {
        this.daysAvailable = 'los ';
        for( let i = 0; i < days.length; i++)
        {

          if(days.length == 1) {
            this.daysAvailable += dayNames[days[i] - 1];
          }
          else {
            if(i === days.length - 1)
              this.daysAvailable = this.daysAvailable + ' y ' + dayNames[days[i] - 1];
            else
              this.daysAvailable = this.daysAvailable + dayNames[days[i] - 1] + ', ';
          }

        }
      }
    }
  }

  replaceLineBreak(s: string)
  {
    return s && s.replace('|', '<br />');
  }
  async getBenefits()
  {
    if( !this.benefits )
    {
      return this.benSer.getByCategory(this.benefit.category)
      .subscribe((benefits: any) =>
      {
        this.benefits = benefits;
        let aux: any = [];
        this.benefits.forEach((el: any) => {
            if (el.id !== this.benefit.id)
            {
              aux.push(el);
            }
        })
        this.benefits = aux;
        return benefits;
      });
    }
    else
      return this.benefits;
  }

  benefitDays(ben: any): string
  {
    const days: any = ben.days.split('').sort();
    const dayNames = [
      'Lunes',
      'Martes',
      'Miércoles',
      'Jueves',
      'Viernes',
      'Sábados',
      'Domingo',
    ];
    if (days.length === 7) {
      return 'Todos los días';
    } else if (days.includes([1, 2, 3, 4, 5])) {
      return 'De Lunes a Viernes';
    } else {
      let message = '';
      for (let i = 0; i < days.length; i++) {
        if (i === days.length - 2){
          message = message + dayNames[days[i] - 1];
        }
        else if (i === days.length - 1) {
          message = message + ' y ' + dayNames[days[i] - 1];
        }
        else {
          message = message + dayNames[days[i] - 1] + ', ';
        }
      }
      return message;
    }
    return ben.benefit_discount;
  }
  showSpinner()
  {
    this.spinnerService.show();
  }
  hideSpinner()
  {
    this.spinnerService.hide();
  }
  scrollTo(el: any)
  {
    this.spinnerService.show();
    el.scrollIntoView();
    setTimeout(() => { this.hideSpinner() }, 1500);
  }
  getMapOptions()
  {
      const styles: Array<any> = [];

      styles.push({ elementType: 'geometry',                  stylers: [{ color: '#f5f5f5'}]});
      styles.push({ elementType: 'labels.icon',               stylers: [{ visibility: 'off'}]});
      styles.push({ elementType: 'labels.text.fill',          stylers: [{ color: '#616161'}]});
      styles.push({ elementType: 'labels.text.stroke',        stylers: [{ color: '#f5f5f5'}]});
      styles.push({ featureType: 'administrative.land_parcel',
                    elementType: 'labels.text.fill',          stylers: [{ color: '#bdbdbd'}]});
      styles.push({ featureType: 'poi',
                    elementType: 'geometry',                  stylers: [{ color: '#eeeeee'}]});
      styles.push({ featureType: 'poi',
                    elementType: 'labels.text.fill',          stylers: [{color: '#757575'}]});
      styles.push({ featureType: 'poi.park',
                    elementType: 'geometry',                  stylers: [{ color: '#e5e5e5'}]});
      styles.push({ featureType: 'poi.park',
                    elementType: 'labels.text.fill',          stylers: [{ color: '#9e9e9e'}]});
      styles.push({ featureType: 'road',
                    elementType: 'geometry',                  stylers: [{ color: '#ffffff'}]});
      styles.push({ featureType: 'road.arterial',
                    elementType: 'labels.text.fill',          stylers: [{ color: '#757575'}]});
      styles.push({ featureType: 'road.highway',
                    elementType: 'geometry',                  stylers: [{ color: '#dadada'}]});
      styles.push({ featureType: 'road.highway',
                    elementType: 'labels.text.fill',          stylers: [{ color: '#616161'}]});
      styles.push({ featureType: 'road.local',
                    elementType: 'labels.text.fill',          stylers: [{ color: '#9e9e9e'}]});
      styles.push({ featureType: 'transit.line',
                    elementType: 'geometry',                  stylers: [{ color: '#e5e5e5'}]});
      styles.push({ featureType: 'transit.station',
                    elementType: 'geometry',                  stylers: [{ color: '#eeeeee'}]});
      styles.push({ featureType: 'water',
                    elementType: 'geometry',                  stylers: [{ color: '#a2c0f4'}]});
      styles.push({ featureType: 'water',
                    elementType: 'labels.text.fill',          stylers: [{ color: '#a2c0f4'}]});

      return { styles, disableDefaultUI: true, gestureHandling: 'greedy', draggable: isPlatformBrowser(this.platformId) ? !("ontouchend" in document) : false };
  }
  initSlider()
  {
    this.benefitsSliderOptions =  {
                                    loop: false,    mouseDrag: true,  touchDrag: true,
                                    pullDrag: true, dots: false,      nav: true,
                                    navSpeed: 500,  autoplay: true,   margin: 15,
                                    responsive: { 1:    { items: 1 },
                                                  360:  { items: 2 },
                                                  768:  { items: 3 },
                                                  1024: { items: 4 }}
                                  };

  }
  getWantMyCodeText()
  {
    let text = "";

    if( this.benefit.benefit_type == "TARJETA" || this.esCencosud )
      text = "Quiero mi Beneficio";
    else
      if( this.benefit. codes_left <= 0 )
        text = "Sin Stock"
      else
        text = "Quiero mi código"

    return text;
  }

  getWantMyCodeClass()
  {
    let className = "";

    if( this.benefit.benefit_type != "TARJETA" && this.benefit.codes_left <= 0  )
      className = "disabled";

    return className;
  }

  copyCode()
  {
    navigator.clipboard.writeText(this.benefitCode!);
    this.codeCopied = true;
    setTimeout(() => {
      this.codeCopied = false
    },3000)
  }

  async handleUser(){
    this.currentUser = await this.userService.getCurrentUser();

    const userToken = await this.userService.getAccessToken();

    this.guestUser = !(userToken != null && userToken.length > 0);

    if(!this.guestUser){
      this.name = this.currentUser.person.profile.firstname
    }
  }

  benefitPage(category: string | null){
    let url = '/beneficios-y-descuentos';

    if(category != null){
      url = url + '/' + this.benSer.getCategoryForUrl(category);
    }

    this.router.navigateByUrl(url);
  }

  formatDate(date:string) {
    return date.replace('T00:00:00', '').split('-').reverse().join('/');
  }
}
